"use client";

import { clearConsent } from "@/lib/consent";
import Link from "next/link";

const linkClass = "hover:text-foreground transition-colors";

export function Footer() {
	return (
		<footer className="border-t border-border">
			<div className="h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />

			<div className="max-w-7xl mx-auto px-6 pt-14 pb-10">
				<div className="grid grid-cols-2 md:grid-cols-5 gap-10">
					{/* Brand column */}
					<div className="col-span-2">
						<Link href="/" className="flex items-center gap-2 mb-3">
							<div className="w-5 h-5 bg-primary rounded-md flex items-center justify-center text-primary-foreground font-bold text-xs">
								S
							</div>
							<span className="font-display font-bold tracking-tight text-foreground">
								SendPigeon
							</span>
						</Link>
						<p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
							Email for everything you build. Resend simplicity, indie-friendly
							pricing.
						</p>
						<a
							href="https://haspulse.dev/sendpigeon"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex items-center gap-1.5 mt-4 text-xs text-muted-foreground/70 hover:text-muted-foreground transition-colors"
						>
							<span className="relative flex h-1.5 w-1.5">
								<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" />
								<span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-teal-500" />
							</span>
							Monitored by HasPulse
						</a>
					</div>

					{/* Resources */}
					<div>
						<h3 className="font-display font-semibold text-sm text-foreground mb-3">
							Resources
						</h3>
						<ul className="space-y-2.5 text-sm text-muted-foreground">
							<li>
								<Link href="/docs" className={linkClass}>
									Docs
								</Link>
							</li>
							<li>
								<Link href="/guides" className={linkClass}>
									Guides
								</Link>
							</li>
							<li>
								<Link href="/templates" className={linkClass}>
									Templates
								</Link>
							</li>
							<li>
								<Link href="/blog" className={linkClass}>
									Blog
								</Link>
							</li>
						</ul>
					</div>

					{/* Tools */}
					<div>
						<h3 className="font-display font-semibold text-sm text-foreground mb-3">
							Tools
						</h3>
						<ul className="space-y-2.5 text-sm text-muted-foreground">
							<li>
								<Link href="/tools" className={linkClass}>
									All Tools
								</Link>
							</li>
							<li>
								<Link href="/tools/local-email-server" className={linkClass}>
									Local Dev Server
								</Link>
							</li>
							<li>
								<Link href="/tools/email-builder" className={linkClass}>
									Email Builder
								</Link>
							</li>
						</ul>
					</div>

					{/* Company */}
					<div>
						<h3 className="font-display font-semibold text-sm text-foreground mb-3">
							Company
						</h3>
						<ul className="space-y-2.5 text-sm text-muted-foreground">
							<li>
								<a href="mailto:info@sendpigeon.dev" className={linkClass}>
									Contact
								</a>
							</li>
							<li>
								<Link href="/terms" className={linkClass}>
									Terms
								</Link>
							</li>
							<li>
								<Link href="/privacy" className={linkClass}>
									Privacy
								</Link>
							</li>
							<li>
								<button
									type="button"
									onClick={() => clearConsent()}
									className={linkClass}
								>
									Cookie Settings
								</button>
							</li>
						</ul>
					</div>
				</div>

				{/* Bottom bar */}
				<div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-muted-foreground/70">
					<p>
						© {new Date().getFullYear()} SendPigeon · Delivery powered by AWS
						SES
					</p>
				</div>
			</div>
		</footer>
	);
}
